import React, { useEffect, useState } from "react";
import { inject, observer } from 'mobx-react';
import Link from '@material-ui/core/Link';
import MaterialTable, { MTableToolbar } from "material-table";
import TableRow from "@material-ui/core/TableRow";
import Modal from '@material-ui/core/Modal';
import { employeesByAccountColumns, qarManagersOptions } from '../../helper/constants';
import '../QaReviewPanel/QaReviewPanel.css';
import Grid from "@material-ui/core/Grid";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Typography, IconButton } from '@material-ui/core';
import { HtmlTooltip } from '../HtmlTooltip/HtmlTooltip';
import { chameleonSystem } from '../../helper/constants';

const EmployeesPerAccount = inject('RootStore')(observer(({ RootStore }) => {

    const [pgModalOpen, setPgModalOpen] = useState(false);
    const [pgModalData, setPgModalData] = useState([]);
    const [roleName, setRoleName] = useState("");

    useEffect((() => {
        RootStore.qarStore.getAllEmployeesByAccountId(RootStore.qarStore.currentlySelectedAccountForReview.id, RootStore.qarStore.currentComplianceReviewId)
    }), [RootStore.qarStore]);

    const tableName = `${RootStore.qarStore.currentlyReviewedSystemForReview.name} / ${RootStore.qarStore.currentlySelectedAccountForReview.name} / Employees`

    const handleRoleClick = (ev, role) => {
        ev.preventDefault();
        RootStore.qarFormStore.loadRolePermissionInfo(role.id);
        setRoleName(role.name);
        RootStore.qarStore.isRoleContentModalOpened = true;
    }

    const handleModalClose = () => {
        RootStore.qarStore.isRoleContentModalOpened = false;
        RootStore.qarStore.groupsByRole = [];
        setRoleName("");
    }

    const rolesColumn = {
      title: "Roles",
      field: "roles",
      render: (rowData) => (
        <>
          {rowData.roles.map((x) => (
            <TableRow key={x.id}>
                <Link href="#" onClick={(ev) => handleRoleClick(ev, x)}>{x.name}</Link>
                <HtmlTooltip title={<><Typography color="inherit" variant="caption">Click on role name to see its groups.</Typography></>}>
                    <IconButton aria-label="delete" size="small"><HelpOutlineIcon fontSize="inherit" /></IconButton>
                </HtmlTooltip>
            </TableRow>
          ))}
        </>
      ),
      customFilterAndSearch: (term, rowData) => {
        const filter = term.toLowerCase();
        const roles = rowData.roles
          .map((x) => x.name)
          .join()
          .toLowerCase();

        return roles.indexOf(filter) !== -1;
      },
    };

    const handleUsernameClick = (event, accountData) => {
        event.preventDefault(); // this prevents appending hashtag to the url
        setPgModalData(accountData);
        setPgModalOpen(true);
    }

    const defaultTableOptions = {
        filtering: false,
        grouping: false,
        draggable: false,
        paging: true,
        search: false,
        toolbar: false,
        showTitle: false,
        sorting: true,
        pageSize: 10
    };

    const renderUserPermissionGroupsTable = () => {
        if(pgModalData.length === 0 ){
            return <></>
        }
        
        return (
            <>
                <h2>
                    User '{pgModalData.username}' has a total of {pgModalData.permissionGroups.length} permission {pgModalData.permissionGroups.length !== 1 ? "groups" : "group"} in {RootStore.qarStore.currentlySelectedAccountForReview.name} ({RootStore.qarStore.currentlyReviewedSystemForReview.name})
                </h2>

                <MaterialTable
                    options={{
                        ...defaultTableOptions,
                        filtering: true,
                        paging: true,
                        search: true,
                        toolbar: true,
                        pageSizeOptions: [5, 10, 15]
                    }}
                    data={pgModalData.permissionGroups}
                    columns={[
                        { title: 'Name', field: 'name', defaultSort: "asc" },
                        { title: 'Description', field: 'description' }
                    ]}
                />
            </>
        );
    }

    const usernameColumn = {
      title: "Username",
      field: "username",
      render: (rowData) => {
          return (
          <>
          <Link href="#" onClick={(event) => handleUsernameClick(event, rowData)}>{rowData.username}</Link>
          <HtmlTooltip title={
              <>
                <Typography color="inherit" variant="caption">
                  Click on username to see its permission groups.
                </Typography>
              </>
            }
          >
            <IconButton aria-label="delete" size="small"><HelpOutlineIcon fontSize="inherit" /></IconButton>
          </HtmlTooltip>
        </>);
      },
    };

    employeesByAccountColumns[1] = usernameColumn;//overwrite originally defined username column

    const renderRolePermissionGroupsTable = () => {
        const rolePermissionInfo = RootStore.qarFormStore.rolePermissionInfo;

        if (rolePermissionInfo === undefined) {
            return;
        }

        const columns = [
            { title: 'Name', field: 'name', defaultSort: "asc" },
            { title: 'Description', field: 'description' },
        ]

        if (rolePermissionInfo.systemName === chameleonSystem) {
            columns.push({ title: 'Permission Actions', field: 'permissionActions', render: (rowdata) => <>{rowdata.permissionActions?.join(', ')}</> })
        }

        return (
            <>
                <h2>Role '{roleName}' has a total of {rolePermissionInfo.rolePermissions.length} permission {rolePermissionInfo.rolePermissions.length !== 1 ? "groups" : "group"}</h2>
                <MaterialTable
                    options={{
                        ...defaultTableOptions,
                        filtering: true,
                        paging: true,
                        search: true,
                        toolbar: true,
                        pageSizeOptions: [5, 10, 15]
                    }}
                    data={rolePermissionInfo.rolePermissions}
                    columns={columns}
                />
            </>
        );
    }

    return (
      <>
        <MaterialTable
          title=""
          data={RootStore.qarStore.employeesByAccount}
          columns={[...employeesByAccountColumns, rolesColumn]}
          options={qarManagersOptions}
          localization={{
            toolbar: {
              exportCSVName: "Export as XLSX",
            },
          }}
          components={{
            Toolbar: (tableProps) => (
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={3}
              >
                <Grid item sm={4}>
                  <h4 style={{ marginLeft: "10px" }}>{tableName}</h4>
                </Grid>
                <Grid item sm={3} style={{ textAlign: "right" }}>
                  <h4>
                    {new Date(RootStore.qarStore.creationDate).toUTCString()}
                  </h4>
                  ({new Date(RootStore.qarStore.creationDate).toLocaleString()} local time)
                </Grid>
                <HtmlTooltip
                  title={
                    <React.Fragment>
                      <Typography color="inherit" variant="caption">
                        This is the compliance review creation date.
                      </Typography>
                    </React.Fragment>
                  }
                >
                  <IconButton aria-label="delete" size="small">
                    <HelpOutlineIcon fontSize="inherit" />
                  </IconButton>
                </HtmlTooltip>
                <Grid item sm={4} style={{ textAlign: "left" }}>
                  <MTableToolbar {...tableProps} />
                </Grid>
              </Grid>
            ),
          }}
        />
        <Modal
          open={RootStore.qarStore.isRoleContentModalOpened}
          onClose={handleModalClose}
          aria-labelledby="role-modal-title"
          aria-describedby="role-modal-description"
        >
          <div className="role-content-modal">
            {renderRolePermissionGroupsTable()}
          </div>
        </Modal>
        <Modal
          open={pgModalOpen}
          onClose={() => {
            setPgModalOpen(false);
            setPgModalData([]);
          }}
          aria-labelledby="role-modal-title"
          aria-describedby="role-modal-description"
        >
          <div className="review-history-modal" id="review-history-modal">
            {renderUserPermissionGroupsTable()}
          </div>
        </Modal>
      </>
    );
}));

export default EmployeesPerAccount;